var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tabBarRef",staticClass:"tab-bar"},[_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,class:['tab', { active: _vm.activeTab === index }],on:{"click":function($event){return _vm.selectTab(index)}}},[_c('span',[_vm._v(_vm._s(tab))])])}),_c('div',{staticClass:"indicator",style:(_vm.indicatorStyle)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }